import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import LightBulbHint from 'views/common/components/UI/LightBulbHint';

export const StyledBox = styled(Box)(({ theme }) => ({
  '& .CMParagraph': {
    fontSize: theme.typography.pxToRem(16),
  },
}));

export const StyledLightBulbHint = styled(LightBulbHint)(({ theme }) => ({
  backgroundColor: 'rgba(243, 224, 94, 0.10)',
  padding: `${theme.spacing(1.5)} !important`,
  paddingRight: `${0} !important`,
  color: theme.palette.secondary.light,
  margin: theme.spacing(1.5, 0),
}));
